import { FC } from 'react'
import { Formik } from 'formik'
import * as Yup from 'yup'
import { useTranslation } from 'next-i18next'
import { observer } from 'mobx-react'
import { IJobCategoryBase, UserProfileJobHuntingStatus, UserProfileYearsOfExperience } from '@/types'
import { KeywordSearchGroup } from '@/components/organisms/KeywordSearchGroup'
import { KeywordSearchGroupForm } from '@/components/molecules/KeywordSearchGroupForm'
import { FormItem } from '@/components/atoms/FormItem'
import { KeywordSearchGroupFormKeywordField } from '@/components/molecules/KeywordSearchGroupFormKeywordField'
import { JobHuntingStatusCheckboxField } from '@/components/molecules/JobHuntingStatusCheckboxField'
import { YearsOfExperienceCheckboxField } from '@/components/molecules/YearsOfExperienceCheckboxField'
import { JobCategoriesField } from '@/components/atoms/JobCategoriesField'
import styles from './index.module.scss'

export type FetchJobSeekersValues = {
  keyword: string
  jobHuntingStatus: UserProfileJobHuntingStatus[]
  primaryJobCategories: string[]
  yearsOfExperience: UserProfileYearsOfExperience[]
}

type Props = {
  search: (input: FetchJobSeekersValues) => Promise<void>
}

type Value = {
  keyword: string
  jobHuntingStatus: UserProfileJobHuntingStatus[]
  primaryJobCategories: IJobCategoryBase[]
  yearsOfExperience: UserProfileYearsOfExperience[]
}

export const KeywordSearchGroupForJobSeekers: FC<Props> = observer(({ search }) => {
  const { t } = useTranslation(['companies-users-[id]', 'search', 'p'])

  const initialValue: Value = {
    keyword: '',
    jobHuntingStatus: [],
    primaryJobCategories: [],
    yearsOfExperience: [],
  }

  const validationSchema = Yup.object().shape({})

  return (
    <div className={styles.container}>
      <KeywordSearchGroup>
        <Formik
          initialValues={initialValue}
          validationSchema={validationSchema}
          onSubmit={async (values: Value, actions) => {
            await search({
              keyword: values.keyword,
              jobHuntingStatus: values.jobHuntingStatus ? values.jobHuntingStatus : [],
              primaryJobCategories: values.primaryJobCategories.map((primaryJobCategory) => primaryJobCategory.id),
              yearsOfExperience: values.yearsOfExperience ? values.yearsOfExperience : [],
            })
            actions.setSubmitting(false)
          }}
        >
          {({ isSubmitting, setFieldValue, values }) => {
            return (
              <KeywordSearchGroupForm
                renderPrimaryForm={() => <KeywordSearchGroupFormKeywordField />}
                isSubmitting={isSubmitting}
              >
                <FormItem label='Project hunting status'>
                  <JobHuntingStatusCheckboxField />
                </FormItem>
                <FormItem label='Project categories'>
                  <JobCategoriesField
                    selectedJobCategories={values?.primaryJobCategories}
                    setFieldValue={(primaryJobCategories) =>
                      setFieldValue('primaryJobCategories', primaryJobCategories)
                    }
                    placeholder={t('search:職種を検索')}
                  />
                </FormItem>
                <FormItem label='Years of experience'>
                  <YearsOfExperienceCheckboxField />
                </FormItem>
              </KeywordSearchGroupForm>
            )
          }}
        </Formik>
      </KeywordSearchGroup>
    </div>
  )
})
